import { useQuery } from 'react-query';

import { checkAvailableCalendarSlotsRoute } from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useCheckAvailableCalendarSlotsProps = {
  enabled: boolean;
  companyId?: number;
  jobId?: number | string;
  application_ids?: number[];
};

export const useCheckAvailableCalendarSlots = ({
  enabled = false,
  companyId,
  jobId,
  application_ids,
}: useCheckAvailableCalendarSlotsProps) => {

  const applicationsCountsKey = 'calendarSlots';

  const buildQueryString = () => {
    const params = new URLSearchParams();

    if (companyId !== undefined) {
      params.append('company_id', companyId.toString());
    }

    if (jobId !== undefined) {
      params.append('job_id', jobId.toString());
    }

    if (application_ids && application_ids.length > 0) {
      params.append('application_ids', application_ids.join(','));
    }

    return params.toString();
  };

  const { data: calendarSlotsData } = useQuery({
    enabled: enabled,
    queryKey: [applicationsCountsKey, jobId, companyId, application_ids],
    queryFn: () => {
      const queryString = buildQueryString();
      return axiosInstance
        .get(`${checkAvailableCalendarSlotsRoute}?${queryString}`)
        .then((res) => res.data);
        
      },
      refetchOnWindowFocus: false,
  });

  return {
    calendarSlotsData,
  };
};
